import React, { useMemo } from 'react';
import { Checkbox, Fieldset } from '@innovationnorway/cl-react';
import { SelfClassification } from 'src/api/v2';
import { useTranslation } from 'react-i18next';

type Props = {
  value: Set<SelfClassification>;
  onChange: (nextValue: Set<SelfClassification>) => void;
  className?: string;
};

const SelfClassificationSelector: React.FC<Props> = ({ value, onChange, className }) => {
  const { t: tSiva } = useTranslation('siva');

  const options = useMemo(() => {
    return [
      {
        text: tSiva('reporting.selfdeclaration.Partner'),
        value: SelfClassification.Partner,
        disabled: value.has(SelfClassification.Independent),
        selected: value.has(SelfClassification.Partner),
      },
      {
        text: tSiva('reporting.selfdeclaration.Associated'),
        value: SelfClassification.Associated,
        disabled: value.has(SelfClassification.Independent),
        selected: value.has(SelfClassification.Associated),
      },
      {
        text: tSiva('reporting.selfdeclaration.Independent'),
        value: SelfClassification.Independent,
        disabled: value.has(SelfClassification.Partner) || value.has(SelfClassification.Associated),
        selected: value.has(SelfClassification.Independent),
      },
    ];
  }, [tSiva, value]);

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    const selectedValue = (event.currentTarget as HTMLInputElement).value as SelfClassification;
    const next = new Set(value);

    if (next.has(selectedValue)) {
      next.delete(selectedValue);
    } else {
      next.add(selectedValue);
    }

    onChange(next);
  };

  return (
    <Fieldset className={className}>
      <Fieldset.Legend>{tSiva('reporting.selfdeclaration.classification' as any)}</Fieldset.Legend>
      {options.map((option) => (
        <Checkbox
          key={option.value}
          label={option.text}
          value={option.value}
          checked={option.selected}
          disabled={option.disabled}
          onChange={handleChange}
        />
      ))}
    </Fieldset>
  );
};

export default SelfClassificationSelector;
